import { type AddToCartResponseItem } from "~/features/cart/cart/api/AddToCart";
import { getAddToCartResponsePrice } from "~/features/cart/cart/utils/addToCartResponseItems";

export interface AddToCartResultDecisionParams {
  responseItems: AddToCartResponseItem[];
}

export interface MultipleEntriesRow {
  designation?: string;
  productCode: string;
  quantity: number;
  netPrice?: number;
  saleNetPrice?: number;
}

export function shouldRenderMultipleEntriesResult({ responseItems }: AddToCartResultDecisionParams): boolean {
  return responseItems.length > 1;
}

export function getMultipleEntriesRows({ responseItems }: AddToCartResultDecisionParams): MultipleEntriesRow[] {
  return responseItems.map((item) => ({
    designation: item.designation,
    productCode: item.productCode,
    quantity: item.quantity,
    netPrice: getAddToCartResponsePrice(item)?.value,
    saleNetPrice: item.specialPrice ? item.actualSalePrice?.value : undefined,
  }));
}
